import { ModalFooterConfig } from '@components/v2/ui/Modal/modal.types';
import LangEnum from '../../../../lang/LangEnum';
import { CopyOrderModalTestIds } from '../../../../utils/testIds/CopyOrderModal.testIds';
import { useBlockOrderWithoutCustomer } from '../../hooks/useBlockOrderWithoutCustomer';
import { UseCopyOrderFooterParams } from '../types/copyOrderModal.types';

export const useCopyOrderFooter = ({
  isSaving,
  isSuggested,
  confirmLabel,
  selectedCustomersCount,
  onCancel,
  onConfirm,
  hasInvalidCustomers,
  keepOriginalCustomer,
}: UseCopyOrderFooterParams): ModalFooterConfig => {
  const { shouldBlockWithoutCustomer } = useBlockOrderWithoutCustomer(isSuggested);

  const isBlockedWithoutCustomer =
    !keepOriginalCustomer && selectedCustomersCount === 0 && shouldBlockWithoutCustomer;

  const getTooltipMessage = () => {
    if (hasInvalidCustomers) {
      return LangEnum.SUGGESTED_ORDER_COPY_INVALID_CUSTOMERS_HELPER_TEXT;
    }
    if (isBlockedWithoutCustomer) {
      return LangEnum.BLOCK_COPY_ORDER_WITHOUT_CUSTOMER_ERROR;
    }
    return undefined;
  };

  return {
    primaryAction: {
      label: confirmLabel,
      isDisabled: isSaving || isBlockedWithoutCustomer || !!hasInvalidCustomers,
      testId: CopyOrderModalTestIds.CONFIRM_BUTTON,
      tooltipMessage: getTooltipMessage(),
      onClick: onConfirm,
    },
    secondaryAction: {
      label: LangEnum.GLOBAL_CANCEL_LABEL,
      onClick: onCancel,
    },
  };
};
